module.exports = __webpack_public_path__ + "img/honnor4.c7605896.png";